import axios from "axios";

const saudicupApi = axios.create({
    baseURL: process.env.VUE_APP_SAUDI_CUP_URL
});
saudicupApi.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);
export default saudicupApi;